<template>
  <div>
    <TheHeader farming></TheHeader>
    <BreadcrumbBar/>
    <PageHero image="farming-woodlands-hero.jpg">
      <TextHeading variant="subtitle">Woodheads</TextHeading>
      <TextHeading variant="xl">
        Trusted by farmers for
        <br>over 100 years
      </TextHeading>
      <BaseButton class="mt-10 text-primary" rounded="full" variant="white" width="small">
        <BaseIcon name="arrow_downward" size="22"></BaseIcon>
      </BaseButton>
    </PageHero>
    <PageGrid>
      <PageMain>
        <PageSection>
          <PageFarmingContent narrow/>
        </PageSection>
        <PageSection title="Latest News">
          <Cards cols="3">
            <CardsCol>
              <CardArticle
                title="British Beef"
                image="farming-news-01.png"
                date="01 Jan 2019"
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Shorthorn Beef"
                image="farming-news-02.png"
                date="12 Dec 2018"
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Yearling Beef"
                image="farming-news-03.png"
                date="07 Sept 2018"
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Dairy Beef"
                image="farming-news-04.png"
                date="30 Aug 2018"
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="British Pork"
                image="farming-news-05.png"
                date="07 Aug 2018"
                rounded
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="British lamb"
                image="farming-news-06.png"
                date="06 Aug 2018"
                rounded
              />
            </CardsCol>
          </Cards>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>
<script>
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import BaseButton from '../elements/BaseButton.vue'
import PageGrid from '../elements/PageGrid.vue'
import PageHero from '../components/PageHero.vue'
import CardArticle from '../components/CardArticle.vue'
import TheFooter from '../components/TheFooter.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import TextHeading from '../elements/TextHeading.vue'
import TheHeader from '../components/TheHeader.vue'
import PageFarmingContent from '../components/PageFarmingContent.vue'
import Cards from '../elements/Cards.vue'
import CardsCol from '../elements/CardsCol.vue'
export default {
  name: 'FarmingWoodheads',
  components: {
    BreadcrumbBar,
    TheHeader,
    TextHeading,
    PageMain,
    PageSection,
    TheFooter,
    CardArticle,
    PageHero,
    PageGrid,
    BaseButton,
    PageFarmingContent,
    CardsCol,
    Cards
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>